<template>
  <BaseWrapper :loading="loadingBonus || loadingCurrentUpline">
    <div class="space-y-4">
      <ol class="flex items-center space-x-4">
        <li
          v-for="(breadcrumb, i) in breadcrumbs"
          :key="breadcrumb.code"
          class="flex items-center space-x-4"
        >
          <Icon
            v-if="i > 0"
            icon="heroicons:chevron-right"
            class="h-4 w-4 text-gray-400"
          />
          <a
            v-if="i !== breadcrumbs.length - 1"
            href=""
            class="text-sm font-medium text-gray-700 hover:text-gray-700"
            @click.prevent="loadUpline(breadcrumb, i)"
            >{{ breadcrumb.code }}</a
          >
          <span
            v-else
            href=""
            class="text-sm font-medium text-gray-500 hover:text-gray-700"
            >{{ breadcrumb.code }}</span
          >
        </li>
      </ol>
      <BaseCard>
        <div class="grid gap-6 sm:grid-cols-2">
          <div>
            <dt class="text-xs text-gray-700">No.Tetap / No.Sementara</dt>
            <dd class="mt-1 text-sm font-bold text-gray-900">
              {{ currentUpline.code ?? '-' }} /
              {{ currentUpline.tempCode ?? '-' }}
            </dd>
          </div>
          <div>
            <dt class="text-xs text-gray-700">Nama Mitra Usaha</dt>
            <dd class="mt-1 text-sm font-bold text-gray-900">
              {{ currentUpline.name ?? '-' }}
            </dd>
          </div>
          <div>
            <dt class="text-xs text-gray-700">Peringkat</dt>
            <dd class="mt-1 text-sm font-bold text-gray-900">
              {{ currentUpline.stage ?? '-' }}
            </dd>
          </div>
          <div>
            <dt class="text-xs text-gray-700">Personal Omzet</dt>
            <dd class="mt-1 text-sm font-bold text-gray-900">
              {{ (currentUpline.omzet ?? 0) | toCurrency }}
            </dd>
          </div>
        </div>
      </BaseCard>
      <Datatable
        :columns="[
          { id: 'code', name: 'No. Tetap' },
          { id: 'name', name: 'Nama' },
          { id: 'stage', name: 'Peringkat' },
          { id: 'pv', name: 'PV', theadClass: 'text-right' },
          { id: 'action', name: 'Lihat', theadClass: 'text-right' },
        ]"
        :total="bonuses.meta.page.total"
        :perPage="bonuses.meta.page.perPage"
        :currentPage="bonuses.meta.page.currentPage"
        :meta="bonuses.meta"
        cursor
        @pagechanged="onPageChange"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="bonus in bonuses.data"
            :key="bonus.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="[classes.td]">
              <span class="font-bold text-gray-900">{{
                bonus.attributes.code
              }}</span>
            </td>
            <td :class="[classes.td]">
              {{ bonus.attributes.name }}
            </td>
            <td :class="[classes.td]">
              {{ bonus.attributes.stage }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                (bonus.attributes.pvpri + bonus.attributes.pvgroup) | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              <a
                href=""
                class="font-medium text-green-600 underline"
                @click.prevent="loadDownline(bonus)"
                >Down</a
              >
            </td>
          </tr>
        </template>
      </Datatable>
    </div>
  </BaseWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  data() {
    return {
      breadcrumbs: [],
      loadingBonus: true,
      loadingCurrentUpline: true,
      currentUplineCode: null,
      currentUpline: {
        bonusId: null,
        code: null,
        tempCode: null,
        name: null,
        stage: null,
        omzet: null,
      },
      bonuses: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
  },
  methods: {
    async loadBonus(params) {
      this.loadingBonus = true;

      const [res, err] = await this.request(`/api/v1/bonus`, {
        params: {
          'filter[upline_code]': this.currentUplineCode,
          'filter[mitra_period_id]': this.me.prev_period.id,
          'page[limit]': 5,
          'fields[bonus]': 'code,name,stage,pvpri,pvgroup',
          ...params,
        },
      });

      if (!err) {
        this.bonuses = res;
      }

      this.loadingBonus = false;
    },
    async loadCurrentUpline() {
      this.loadingCurrentUpline = true;

      const [res, err] = await this.request(
        `/api/v1/bonus/${this.currentUpline.bonusId}`,
        {
          params: {
            'fields[bonus]': 'code,temp_code,name,stage,pvpri',
          },
        }
      );

      if (!err) {
        this.currentUpline.bonusId = res.data.id;
        this.currentUpline.code = res.data.attributes.code;
        this.currentUpline.tempCode = res.data.attributes.temp_code;
        this.currentUpline.name = res.data.attributes.name;
        this.currentUpline.stage = res.data.attributes.stage;
        this.currentUpline.omzet = res.data.attributes.pvpri;
      }

      this.loadingCurrentUpline = false;
    },
    loadDownline(upline) {
      this.currentUplineCode = upline.attributes.code;
      this.currentUpline.bonusId = upline.id;

      this.breadcrumbs.push({
        code: this.currentUplineCode,
        bonusId: this.currentUpline.bonusId,
      });

      this.loadCurrentUpline();
      this.loadBonus();
    },
    loadUpline(breadcrumb, index) {
      this.currentUplineCode = breadcrumb.code;
      this.currentUpline.bonusId = breadcrumb.bonusId;

      this.breadcrumbs.splice(index + 1);

      this.loadCurrentUpline();
      this.loadBonus();
    },
    onPageChange(page) {
      this.loadBonus(page);
    },
  },
  created() {
    this.currentUplineCode = this.me.office_code;
    this.currentUpline.bonusId = this.me.current_bonus_id;

    this.breadcrumbs.push({
      code: this.currentUplineCode,
      bonusId: this.currentUpline.bonusId,
    });

    this.loadCurrentUpline();
    this.loadBonus();
  },
};
</script>
